import React from "react";
import { Link } from "react-router-dom";


const TBAdminTopNav = () => {
  return (
    <div className="tbadmin-topnav">
      <ul>
         <li>
          <Link to="/tbadmin/organization">Organization</Link>
        </li>
        <li>
          <Link to="/tbadmin/signup">Signup</Link>
        </li>
        
        <li>
          <Link to="/tbadmin/add-dashboard">Add Dashboard</Link>
        </li>
        <li>
          <Link to="/tbadmin/add-form">Add Form</Link>
        </li>
        <li>
          <Link to="/tbadmin/add-data">Add Data</Link>
        </li>
        <li>
          <Link to="/tbadmin-logout">Logout</Link>
        </li>
      </ul>
    </div>
  );
};

export default TBAdminTopNav;
